import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import App from "./App";
import i18n, { translate_service } from "@libs/translate/translate";
import AuthServiceVuePlugin from "@libs/authorization/AuthServiceVuePlugin";
import store from "@model/store/index.js";
import router from "./routes/main";
import billingServiceInit from "./model/helpers/billing/billingServiceInit";
import "./libs/tooltip/projects/wf/tooltip";

// https://vuescrolljs.yvescoding.org/
import vuescroll from "vuescroll/dist/vuescroll-native";

billingServiceInit();
Vue.config.productionTip = false;

translate_service.afterTranslationLoad().then(() => {
  Vue.use(Vuex);
  Vue.use(VueRouter);
  Vue.use(vuescroll);
  Vue.use(AuthServiceVuePlugin);
  new Vue({
    render: h => h(App),
    store,
    i18n,
    router,
  }).$mount("#app");
});
